import WidgetModule from "@eisinc/Overrides/Widgets/Requisitions/RequisitionsProductListLine";

export * from "@eisinc/Overrides/Widgets/Requisitions/RequisitionsProductListLine";

export default WidgetModule;
